import { render } from "./FirstBlock.vue?vue&type=template&id=13519e66&scoped=true"
import script from "./FirstBlock.vue?vue&type=script&lang=js"
export * from "./FirstBlock.vue?vue&type=script&lang=js"

import "./FirstBlock.vue?vue&type=style&index=0&id=13519e66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13519e66"]])

export default __exports__